import { jsx } from 'react/jsx-runtime.js';
import cn from 'classnames';
import styles from './Layout.module.css.js';
export { default as layoutStyles } from './Layout.module.css.js';

var Layout = function Layout(props) {
  var children = props.children,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className;
  return jsx("div", {
    className: cn(styles.horizontalPadding, className),
    children: children
  });
};

export { Layout };
